import { Control } from 'react-hook-form';
import React from 'react';

import { Checkbox } from 'semantic-ui-react';
import './FilterFields.scss';
import { useFilterController } from '../useFilterForm';

interface Props {
  name: string;
  valuesList: string[];
  labelsList: string[];
  title: string;
  control: Control;
  className?: string;
}

export const CheckboxListField = ({ name, valuesList, labelsList, title, control, className }: Props) => {
  const controller = useFilterController({ name, control });
  const fieldValue = Array.isArray(controller.field.value) ? controller.field.value : [controller.field.value];
  const onChange = controller.field.onChange;

  const isChecked = (checkboxValue: string) => fieldValue.includes(checkboxValue);
  const onChecked = (checked: boolean, checkboxValue: string) => {
    if (checked) {
      onChange({ target: { value: fieldValue.concat(checkboxValue) } });
    } else {
      onChange({ target: { value: fieldValue.filter((value: string) => value !== checkboxValue) } });
    }
  };

  return (
    <div className={['checkbox-list-field', className].join(' ')}>
      <span className="checkbox-list-field__title">{title}</span>
      <div className="checkbox-list-field__values">
        {valuesList.map((checkboxValue, i) => (
          <Checkbox
            key={checkboxValue}
            name={controller.field.name}
            checked={isChecked(checkboxValue)}
            onChange={(_: any, { checked }: any) => onChecked(checked, checkboxValue)}
            label={labelsList[i]}
          />
        ))}
      </div>
    </div>
  );
};
